import { Button, Col, Image, Typography } from "antd";
import React from "react";
import {
  InputSelect,
  InputText,
  InputTimePicker,
  SimpleInputSelectMultiple,
} from "../../../../shared/components";
import Upload from "../../../../shared/components/ui/inputs/Upload";
import { PATH_S3_BUCKET } from "../../../../shared/utils/constants";
import { useEditRulesSushiLunch, useRulesSushiLunch } from "../../hooks";
import { SelectedDaysType } from "./RulesSushiLunchForm";

const { Title } = Typography;

export const EditRulesSushiLunchForm = ({
  setOpenModalEditRule,
  ruleId,
}: {
  setOpenModalEditRule: (val: boolean) => void;
  ruleId: number;
}) => {
  const [selectedDays, setSelectedDays] = React.useState<string[]>([]);
  const [days, setDays] = React.useState<SelectedDaysType>({
    monday: "false",
    tuesday: "false",
    wednesday: "false",
    thursday: "false",
    friday: "false",
    saturday: "false",
    sunday: "false",
  });

  const { ruleById, loading } = useRulesSushiLunch({
    rule_id: ruleId,
  });

  const { editRule, control, setValue } = useEditRulesSushiLunch({
    setOpenModalEditRule,
    ruleById,
    days,
  });

  const handleDaysChange = (values: string[]) => {
    setSelectedDays(values);

    const updatedDays: SelectedDaysType = {
      monday: values.includes("monday") ? "true" : "false",
      tuesday: values.includes("tuesday") ? "true" : "false",
      wednesday: values.includes("wednesday") ? "true" : "false",
      thursday: values.includes("thursday") ? "true" : "false",
      friday: values.includes("friday") ? "true" : "false",
      saturday: values.includes("saturday") ? "true" : "false",
      sunday: values.includes("sunday") ? "true" : "false",
    };
    setDays(updatedDays);
  };

  React.useEffect(() => {
    if (ruleById) {
      const activeDays = Object.keys(ruleById).filter(
        (day) => ruleById[day] === "true"
      );
      setSelectedDays(activeDays);
    }
  }, [ruleById]);

  return (
    <form onSubmit={editRule}>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Nombre:
        </Title>
        <InputText
          placeHolder="Nombre de la regla"
          name="name"
          control={control}
        />
      </Col>

      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Días disponibles:
        </Title>
        <SimpleInputSelectMultiple
          label="Selecciona los días"
          onChange={(e) => handleDaysChange(e)}
          valuesSelect={selectedDays}
          clearValue={(value: string) =>
            handleDaysChange(selectedDays.filter((day) => day !== value))
          }
          showSearch={true}
          dataOptions={[
            { title: "Lunes", value: "monday" },
            { title: "Martes", value: "tuesday" },
            { title: "Miércoles", value: "wednesday" },
            { title: "Jueves", value: "thursday" },
            { title: "Viernes", value: "friday" },
            { title: "Sábado", value: "saturday" },
            { title: "Domingo", value: "sunday" },
          ]}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Estado:
        </Title>
        <InputSelect
          name="status"
          control={control}
          dataOptions={[
            { title: "Activo", value: "active" },
            { title: "Inactivo", value: "inactive" },
          ]}
          label="Estado"
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Aplica a:
        </Title>
        <InputSelect
          name="apply_to"
          control={control}
          dataOptions={[
            { title: "Premium", value: "premiun" },
            { title: "Normal", value: "normal" },
          ]}
          label="Aplica a"
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Hora inicio:
        </Title>
        <InputTimePicker
          placeHolder="Seleccione hora de inicio"
          name="start_time"
          control={control}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Hora fin:
        </Title>
        <InputTimePicker
          placeHolder="Seleccione hora de fin"
          name="end_time"
          control={control}
        />
      </Col>
      <Col
        span={24}
        style={{
          display: "flex",
          marginTop: "10px",
          justifyContent: "center",
          alignItems: "flex-start",
          flexDirection: "column",
        }}
      >
        <Title style={{ marginBottom: "1.5px" }} level={5}>
          Banner actual:
        </Title>
        {ruleById?.banner_path && (
          <Image
            width={200}
            src={`${PATH_S3_BUCKET}/${ruleById.banner_path}`}
            alt="Banner"
            style={{ marginBottom: "10px" }}
          />
        )}
        <Upload
          filePath="sushi-lunch-banners"
          placeHolder="Actualizar Banner"
          onUploadedFile={(file) => {
            setValue("banner_path", file.fileKey);
          }}
        />
      </Col>
      <Button
        htmlType="submit"
        style={{
          width: "100%",
          marginTop: 10,
        }}
        type="primary"
        shape="round"
        size="large"
        loading={loading}
      >
        Editar
      </Button>
    </form>
  );
};
